import React, { useContext} from "react";
import { BI_AUT002Context } from "../context";

export default function GridHeader() {

  const { 
    isLoading,
    gridComponents
  } = useContext(BI_AUT002Context);

  const headerComponentsRender = gridComponents?.HEADER[0]?.Childrens || []

  if(!headerComponentsRender.length) return null

  return (
    <>
      {/* <Row>
        <Col lg={12} className={`mb-3 nav-accordion-custom ${isLoading ? "disabled" : ""}`} >
          <Row className="d-flex align-items-center justify-content-between pb-3">
            
          </Row>
        </Col>
      </Row> */}
    </>
  );
}
